import { z } from "zod";

export const referenceNodeSchema = z
  .object({
    ref: z.string().regex(/^[a-zA-Z][a-zA-Z0-9]*\.[a-zA-Z][a-zA-Z0-9]*$/),
  })
  .strict();

export const constantNodeSchema = z
  .object({
    const: z.number().int(),
  })
  .strict();

export type ReferenceNode = z.infer<typeof referenceNodeSchema>;
export type ConstantNode = z.infer<typeof constantNodeSchema>;

export interface OperatorNode {
  op: string;
  args: RuleNode[];
}
export type RuleNode = OperatorNode | ReferenceNode | ConstantNode;

export const ruleNodeSchema: z.ZodType<RuleNode> = z.lazy(() =>
  z.union([operatorNodeSchema, referenceNodeSchema, constantNodeSchema]),
);

export const operatorNodeSchema: z.ZodType<OperatorNode> = z.lazy(() =>
  z
    .object({
      op: z.string().min(1),
      args: z.array(ruleNodeSchema).min(1).max(10),
    })
    .strict(),
);

export const correlationRuleItemSchema = z.object({
  ruleId: z.number(),
  ruleType: z.string().min(1),
  rule: ruleNodeSchema,
  createdDate: z.number(),
  updatedDate: z.number(),
});

export const correlationRulesResponseSchema = z.object({
  integrationId: z.number(),
  rules: z.array(correlationRuleItemSchema).max(50),
});

export const replaceCorrelationRulesRequestSchema = z.object({
  rules: z.array(ruleNodeSchema).max(50),
});

export const addCorrelationRulesRequestSchema = z.object({
  rules: z.array(ruleNodeSchema).min(1).max(50),
});

export type CorrelationRuleItem = z.infer<typeof correlationRuleItemSchema>;
export type CorrelationRulesResponse = z.infer<
  typeof correlationRulesResponseSchema
>;
export type ReplaceCorrelationRulesRequest = z.infer<
  typeof replaceCorrelationRulesRequestSchema
>;
export type AddCorrelationRulesRequest = z.infer<
  typeof addCorrelationRulesRequestSchema
>;
